import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    checkboxLabel: {
      margin: 0,
    },
    checkbox: {
      alignSelf: 'flex-start',
      padding: 0,
      marginRight: theme.spacing(1.5),
      marginTop: '2px',
    },
    checkboxError: {
      color: 'red',
    },
  }),
);
